import { IconProps } from "../../utils/global-types/global-types";

const PlusIcon = ({
  className,
  stroke,
  strokeWidth,
  ...rest
}: IconProps & { stroke?: string; strokeWidth?: number }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="18"
    height="18"
    fill="none"
    viewBox="0 0 18 18"
    className={className ? className : "w-6 h-6"}
    {...rest}
  >
    <g clipPath="url(#clip0_6304_90606)">
      <path
        fill="currentColor"
        stroke={stroke}
        strokeWidth={strokeWidth}
        fillRule="evenodd"
        d="M8 8H2.5a1 1 0 0 0 0 2H8v5.5a1 1 0 0 0 2 0V10h5.5a1 1 0 0 0 0-2H10V2.5a1 1 0 0 0-2 0z"
        clipRule="evenodd"
      ></path>
    </g>
    <defs>
      <clipPath id="clip0_6304_90606">
        <path fill="currentColor" d="M1 1h16v16H1z"></path>
      </clipPath>
    </defs>
  </svg>
);

export default PlusIcon;
